export default __webpack_public_path__ + "0674cdf070471e6f6bd0a69f6a9834f3.woff2";